export default __webpack_public_path__ + "static/media/flag-dk.3140e177.svg";